require('angular')
require('angular-route')
require('angular-cookies')
require("angular-bootstrap")
require('../../../core/translation/translation-module')
require('../location-tracking/location-tracking-module')
require('../remote-api/remote-api-module')
require('../auth/auth-module')

PaymentService = require("./payment-service")
PayModalService = require("./pay-modal/pay-modal-service")
PayModalCtrl = require("./pay-modal/pay-modal-controller")
CancelModalService = require("./cancel-modal/cancel-modal-service")
CancelModalCtrl = require("./cancel-modal/cancel-modal-controller")
PaymentLocationInterceptor = require("./payment-location-interceptor")
PaymentInterceptor = require("./payment-interceptor")

modules = [
  'ngRoute'
  'ngCookies'
  'ui.bootstrap'
  'gnp-translation'
  'gnp-location-tracking'
  'gnp-remote-api'
  'gnp-auth'
]

angular.module 'gnp-payment', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/unlock',
      redirectTo: '/'
      permission:
        signInRequired: true
        paymentRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'PayModalCtrl', PayModalCtrl
  .controller 'CancelModalCtrl', CancelModalCtrl
  .factory 'PaymentService', PaymentService
  .factory 'PayModalService', PayModalService
  .factory 'CancelModalService', CancelModalService
  .run PaymentLocationInterceptor
  .run PaymentInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/payment-module.coffee